import {Component, ElementRef, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {InterchangeableComponentGroupNl} from "../_models/interchangeable-component-group-nl";
import {InterchangeableComponentDto} from "../_models/interchangeable-component-dto";
import {UnitLabels} from "../../../enums/unit";
import {CurrencyPipe, DecimalPipe} from "@angular/common";

@Component({
  selector: 'app-interchangeable-components-popup',
  templateUrl: './interchangeable-components-popup.component.html',
  imports: [
    DecimalPipe,
    CurrencyPipe
  ],
  styleUrl: './interchangeable-components-popup.component.scss'
})
export class InterchangeableComponentsPopupComponent implements OnInit {
  protected readonly components: InterchangeableComponentDto[];
  protected readonly group: InterchangeableComponentGroupNl;
  protected readonly UnitLabels = UnitLabels;
  protected readonly parseInt = parseInt;
  private readonly _ref: MatDialogRef<InterchangeableComponentsPopupComponent>;
  private readonly _trigger: ElementRef;

  constructor(ref: MatDialogRef<InterchangeableComponentsPopupComponent>, @Inject(MAT_DIALOG_DATA) data: {
    trigger: ElementRef,
    group: InterchangeableComponentGroupNl,
    components: InterchangeableComponentDto[]
  }) {
    this._ref = ref;
    this._trigger = data.trigger;

    this.group = data.group;
    this.components = data.components.sort((a, b) => a.component.itemName.localeCompare(b.component.itemName));
  }

  ngOnInit(): void {
    const config = new MatDialogConfig();
    const rect = this._trigger.nativeElement.getBoundingClientRect();
    config.position = {left: `${rect.left}px`, top: `${rect.bottom + 10}px`};
    // this._ref.updateSize(config.width, config.height);
    // this._ref.updatePosition(config.position);
  }

  cancel() {
    this._ref.close(null);
  }
}
